import { render, staticRenderFns } from "./AddSupportedCurrencyForm.vue?vue&type=template&id=560990aa&scoped=true"
import script from "./AddSupportedCurrencyForm.vue?vue&type=script&lang=js"
export * from "./AddSupportedCurrencyForm.vue?vue&type=script&lang=js"
import style0 from "./AddSupportedCurrencyForm.vue?vue&type=style&index=0&id=560990aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560990aa",
  null
  
)

export default component.exports